"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var addReadWriteRecipient_1 = require("./addReadWriteRecipient");
var findReadWriteRecipient_1 = require("./findReadWriteRecipient");
var setHasSearchedDirectory_1 = require("./setHasSearchedDirectory");
var setIsSearching_1 = require("./setIsSearching");
var showHideFindResult_1 = require("./showHideFindResult");
var isValidEmailAddress_1 = require("../utils/isValidEmailAddress");
var parseSuspectedDisplayNameEmailAddress_1 = require("../utils/parseSuspectedDisplayNameEmailAddress");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('resolveQueryStringToRecipient')(function resolveQueryStringToRecipient(recipientWell, shouldDirectlyResolve, searchDirectory, resolveIfSingle) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var inputText, result;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setHasSearchedDirectory_1.default(recipientWell, searchDirectory);
                    inputText = recipientWell.queryString.trim();
                    if (!inputText) return [3 /*break*/, 7];
                    if (!shouldDirectlyResolve) return [3 /*break*/, 2];
                    setIsSearching_1.default(recipientWell, false /* isSearching */);
                    result = parseSuspectedDisplayNameEmailAddress_1.default(inputText);
                    return [4 /*yield*/, addReadWriteRecipient_1.default(recipientWell, isValidEmailAddress_1.default(result.EmailAddress.EmailAddress), result)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 2:
                    if (!(recipientWell.queryString.indexOf('@') >= 0 && recipientWell.inForceResolve)) return [3 /*break*/, 4];
                    setIsSearching_1.default(recipientWell, false /* isSearching */);
                    return [4 /*yield*/, addReadWriteRecipient_1.default(recipientWell, isValidEmailAddress_1.default(inputText), null, inputText)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    setIsSearching_1.default(recipientWell, true /* isSearching */);
                    return [4 /*yield*/, findReadWriteRecipient_1.default(recipientWell, recipientWell.queryString, searchDirectory, resolveIfSingle)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    // If query string is empty, hide find result with existing result cleared.
                    setIsSearching_1.default(recipientWell, false /* isSearching */);
                    showHideFindResult_1.default(recipientWell, true /* shouldShowFindResult */, true /* shouldClearFindResult */);
                    _a.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=resolveQueryStringToRecipient.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/resolveQueryStringToRecipient.js
// module id = 2669
// module chunks = 2 3 4 45